<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="applyData" :label-position="labelPosition" ref="applyInfoForm" label-width="140px">
          <el-row type="flex" justify="right">
            <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
            <!--关闭-->
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.no')">
                <el-input class="handle-input" v-model="applyData.applyNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <el-input class="handle-input" v-model="applyData.applyTypeI18n" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="17">
              <el-form-item :label="$t('apply.subject')">
                <el-input class="handle-input" v-model="applyData.subject" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('apply.shortlistedSuppliers')" prop="supplierNames">
                <el-input class="handle-input" v-model="applyData.supplierNames" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('apply.quotationType')">
                <el-input class="handle-input" v-model="applyData.quotationTypeI18n" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('common.createBy')">
                <el-input class="handle-input" v-model="applyData.name" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('common.createDate')">
                <el-input class="handle-input" v-model="applyData.createDate" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('apply.lineDetail')" name="line">
          <el-table :data="applyLineTableData" ref="applyLineTableDataRef" border highlight-current-row class="table">
            <el-table-column sortable prop="pickupPoint" align="center" :label="$t('base.pp.pickupPoint')"></el-table-column>
            <el-table-column sortable prop="dcName" align="center" :label="$t('apply.dc')"></el-table-column>
            <el-table-column sortable prop="temperatureI18n" align="center" :label="$t('apply.temperature')"></el-table-column>
            <el-table-column sortable prop="transportaionMethodI18n" align="center" :label="$t('apply.transportaionMethod')"></el-table-column>
            <el-table-column sortable prop="unitI18n" align="center" :label="$t('apply.unit')"></el-table-column>
            <el-table-column align="center" prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')">
              <template slot-scope="scope">
                {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
              </template>
            </el-table-column>
            <el-table-column sortable prop="remarks" align="center" :label="$t('common.remarks')"></el-table-column>
          </el-table>
        </el-tab-pane>
        <!--附件列表-->
        <el-tab-pane :label="$t('common.attachment')" name="enclosure">
          <el-table :data="fileList" border highlight-current-row class="table">
            <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
              </template>
            </el-table-column>
            <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
            <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
              <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!--附件列表-->
      </el-tabs>

    </div>
  </div>
</template>
<script>
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { fileService } from "../../../api/common/file-utils";
import router from '../../../router';

import { Message } from "element-ui";
export default {
  name: 'apply-detaill',

  data() {
    return {
      labelPosition: 'right',
      applyData: {},
      activeName: 'line',
      applyLineTableData: [],
      showUploadFlag: false,
      supplierIds: [],
      disableFlag: true,
      fileList: [],
      ttQuotationApplyId: ''
    }
  },

  mounted() {
    this.ttQuotationApplyId = this.$route.params.ttQuotationApplyId;
    this.applyPageInit(this.ttQuotationApplyId);
    this.getFiles();
  },

  methods: {
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    historyBack: function () {
      router.replace({
        path: '/sourcing'
      });
    },

    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },

    //页面初始化
    applyPageInit: function (applyId) {
      applyService.getQuotationApplyInfoShow(applyId).then((res) => {
        console.log(res);
        this.applyData = res.quotationApply;
        this.applyLineTableData = res.quotationApplyLine;
        this.supplierIds = res.quotationApply.supplierIds;
      });
    }
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 20px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>